module.exports = __webpack_public_path__ + "img/about01.745d45b0.jpg";